import { createFileRoute } from "@tanstack/react-router";

// The WorkOS sign-in endpoint. The root layout renders SignInEndpointScreen for this path in every
// auth state, so the route only needs to exist.
export const Route = createFileRoute("/login")({
  component: () => null,
});
